import type { FC } from 'react';

import { StyledItemFrame } from './FileUpload.styled';
import type { FileItemFrameProps } from './types';

export const FileItemFrame: FC<FileItemFrameProps> = ({ changed, children, ...rest }) => (
  <StyledItemFrame data-changed={changed ? 'true' : undefined} {...rest}>
    {children}
  </StyledItemFrame>
);

FileItemFrame.displayName = 'FileItemFrame';
